/**
 * 購物車頁的發票欄位：依發票類型／載具切換顯示。
 *
 * 隱藏的欄位會停用（不送出），但購物車已存的舊值不會因此消失：例如先選統編發票填了統編，
 * 再改回一般發票，舊的統一編號仍留在購物車並帶進訂單（2026-11-03 #1057）。
 * 所以停用欄位時，同時放一個同名、空值的隱藏欄位，送出表單或套用優惠碼時把舊值清掉
 * （Shopify 收到空字串會移除該屬性）。
 */
(() => {
  const wrap = document.querySelector('[data-invoice-fields]');
  if (!wrap) return;

  const COMPANY_TYPE = '統編發票';
  const NO_CARRIER = '不需要載具';

  const typeInputs = Array.from(wrap.querySelectorAll('[data-invoice-type-input]'));
  const companyNameRow = wrap.querySelector('[data-invoice-company-name-row]');
  const companyNameInput = wrap.querySelector('[data-invoice-company-name]');
  const taxIdRow = wrap.querySelector('[data-invoice-tax-id-row]');
  const taxIdInput = wrap.querySelector('[data-invoice-tax-id]');
  const carrierRow = wrap.querySelector('[data-invoice-carrier-row]');
  const carrierSelect = wrap.querySelector('[data-invoice-carrier-select]');
  const carrierNumberRow = wrap.querySelector('[data-invoice-carrier-number-row]');
  const carrierNumberInput = wrap.querySelector('[data-invoice-carrier-number]');

  /**
   * 切換一列的顯示與停用，並維護清除舊值用的空白隱藏欄位。
   *
   * @param {HTMLElement} row - 欄位外層。
   * @param {HTMLInputElement|HTMLSelectElement} field - 欄位本身。
   * @param {boolean} visible - 是否顯示並啟用。
   */
  function setRowState(row, field, visible) {
    row.hidden = !visible;
    field.disabled = !visible;
    field.required = visible;

    let clear = row.querySelector('[data-invoice-clear]');
    if (visible) {
      clear?.remove();
    } else if (!clear) {
      clear = document.createElement('input');
      clear.type = 'hidden';
      clear.name = field.name;
      clear.value = '';
      clear.dataset.invoiceClear = '';
      row.append(clear);
    }
  }

  function currentType() {
    const checked = typeInputs.find((input) => input.checked);
    return checked ? checked.value : typeInputs[0]?.value;
  }

  function updateCarrierNumberVisibility() {
    setRowState(carrierNumberRow, carrierNumberInput, carrierSelect.value !== NO_CARRIER);
  }

  function updateVisibility() {
    const isCompany = currentType() === COMPANY_TYPE;

    setRowState(companyNameRow, companyNameInput, isCompany);
    setRowState(taxIdRow, taxIdInput, isCompany);
    setRowState(carrierRow, carrierSelect, !isCompany);

    if (isCompany) {
      setRowState(carrierNumberRow, carrierNumberInput, false);
    } else {
      updateCarrierNumberVisibility();
    }
  }

  typeInputs.forEach((input) => input.addEventListener('change', updateVisibility));
  carrierSelect.addEventListener('change', updateCarrierNumberVisibility);

  updateVisibility();
})();
